import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import type { DebouncedFunc } from 'lodash';
import type { UseQueryResult } from '@tanstack/react-query';
import type { VcsApi } from '@env0/vcs-service/api';
import { useGetVcsRepositories } from 'stores/rq/vcs-connections';

const REPOSITORIES_PAGE_SIZE = 100;
const SEARCH_DEBOUNCE_MS = 600;

// Drives the repository dropdowns: the first page loads on open and typing triggers a debounced
// server-side search, so a connection with tens of thousands of repos no longer enumerates them all.
export const useVcsRepositoriesSearch = (
  vcsType: VcsApi.VcsType,
  connectionType: VcsApi.ConnectionType
): UseQueryResult<VcsApi.GetVcsRepositories.Response> & { onSearch: DebouncedFunc<(searchTerm: string) => void> } => {
  const [search, setSearch] = useState('');

  const query = useGetVcsRepositories(vcsType, connectionType, {
    search: search || undefined,
    page: 1,
    perPage: REPOSITORIES_PAGE_SIZE
  });

  const onSearch = useMemo(() => _.debounce(setSearch, SEARCH_DEBOUNCE_MS), []);
  useEffect(() => () => onSearch.cancel(), [onSearch]);

  return { ...query, onSearch };
};
